export const SET_FORM_STATE_CHANGES_DATA = 'SET_FORM_STATE_CHANGES_DATA';


export const setFormChangesData = (isFormChanges:boolean) => {
    return {
        type: SET_FORM_STATE_CHANGES_DATA,
        payload: {
            isFormChanges
        }
    };
};